"use client";

import { useEffect, useState } from "react";
import { setConfirmListener } from "./confirmBus";

/**
 * Окно подтверждения в стиле приложения. Инлайн-стили с фолбэками токенов —
 * по той же причине, что у VpnChip: стоит над двумя вёрстками (мобильной и
 * десктопной), токены `--op-*` есть не везде.
 */
export default function ConfirmHost() {
  const [ask, setAsk] = useState<{ text: string; resolve: (ok: boolean) => void } | null>(null);

  useEffect(() => {
    setConfirmListener(setAsk);
    return () => setConfirmListener(null);
  }, []);

  if (!ask) return null;
  const close = (ok: boolean) => {
    ask.resolve(ok);
    setAsk(null);
  };
  const btn = { flex: 1, minHeight: 44, border: 0, borderRadius: 12, fontSize: 15, fontWeight: 600, cursor: "pointer" } as const;

  return (
    <div
      role="presentation"
      onClick={() => close(false)}
      style={{ position: "fixed", inset: 0, zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, background: "rgba(0,0,0,0.45)" }}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 380,
          padding: 20,
          borderRadius: 18,
          background: "var(--op-surface, #fff)",
          color: "var(--op-fg, #17191a)",
          boxShadow: "var(--op-shadow, 0 12px 30px -10px rgba(23,25,26,0.35))",
        }}
      >
        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.45 }}>{ask.text}</p>
        <div style={{ marginTop: 18, display: "flex", gap: 8 }}>
          <button type="button" onClick={() => close(false)} style={{ ...btn, background: "var(--op-ghost, #f2f0ed)", color: "var(--op-muted, #55585a)" }}>
            Нет
          </button>
          <button type="button" autoFocus onClick={() => close(true)} style={{ ...btn, background: "var(--op-fg, #17191a)", color: "var(--op-surface, #fff)" }}>
            Да, поставить
          </button>
        </div>
      </div>
    </div>
  );
}
